/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MdmDuplicateCandidateEntity } from './MdmDuplicateCandidateEntity';
import {
    MdmDuplicateCandidateEntityFromJSON,
    MdmDuplicateCandidateEntityFromJSONTyped,
    MdmDuplicateCandidateEntityToJSON,
    MdmDuplicateCandidateEntityToJSONTyped,
} from './MdmDuplicateCandidateEntity';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface CandidatesResponse
 */
export interface CandidatesResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CandidatesResponse
     */
    success?: boolean;
    /**
     * 
     * @type {Array<MdmDuplicateCandidateEntity>}
     * @memberof CandidatesResponse
     */
    data?: Array<MdmDuplicateCandidateEntity>;
    /**
     * 
     * @type {number}
     * @memberof CandidatesResponse
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof CandidatesResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CandidatesResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {string}
     * @memberof CandidatesResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidatesResponse
     */
    userTimezone?: string;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof CandidatesResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof CandidatesResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the CandidatesResponse interface.
 */
export function instanceOfCandidatesResponse(value: object): value is CandidatesResponse {
    return true;
}

export function CandidatesResponseFromJSON(json: any): CandidatesResponse {
    return CandidatesResponseFromJSONTyped(json, false);
}

export function CandidatesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CandidatesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(MdmDuplicateCandidateEntityFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function CandidatesResponseToJSON(json: any): CandidatesResponse {
    return CandidatesResponseToJSONTyped(json, false);
}

export function CandidatesResponseToJSONTyped(value?: CandidatesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(MdmDuplicateCandidateEntityToJSON)),
        'total': value['total'],
        'page': value['page'],
        'pageSize': value['pageSize'],
        'errorMessage': value['errorMessage'],
        'userTimezone': value['userTimezone'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

